<script setup lang="ts">
import type { Task } from '~/models/AssignTask'
import { ref } from 'vue'
import { KsButton, KsDialog, KsSpinner } from '@aschehoug/kloss'
import TeleportationTarget from '~/models/TeleportationTarget'
import { useAssignTask } from '~/composables/useAssignTask'

const { task, disableBtn = false } = defineProps<{ task: Task; disableBtn?: boolean }>()

const { deleteTask } = useAssignTask()

const open = ref(false)
</script>

<template>
  <KsButton
    class="mr-auto"
    shape="rounded"
    :disabled="disableBtn"
    style="--ks-secondary: rgb(var(--au-coral-40))"
    @click="open = true"
  >
    Slett prøven
  </KsButton>
  <Teleport :to="TeleportationTarget.AppTop">
    <KsDialog
      :open
      :title="task.name"
      size="small"
      @close="open = false"
    >
      <template #body>
        <p>Er du helt sikker på at du vil slette terminprøven: <b>{{ task.name }}</b>?</p>
      </template>
      <template #footer>
        <div class="flex items-center justify-center gap-4">
          <KsButton
            variant="secondary"
            shape="rounded"
            :disabled="deleteTask.isPending.value"
            @click="open = false"
          >
            Avbryt
          </KsButton>
          <KsButton
            variant="primary"
            style="--ks-primary: rgb(var(--au-coral-50)); --ks-secondary: rgb(var(--au-coral-40))"
            shape="rounded"
            :disabled="deleteTask.isPending.value"
            @click="deleteTask.mutateAsync(task)"
          >
            <div class="flex gap-1">
              {{ deleteTask.isPending.value ? 'Sletter prøven...' : 'Slett prøven' }}
              <KsSpinner
                v-if="deleteTask.isPending.value"
                style="--ks-primary: rgb(var(--au-seagreen-30))"
                size="small"
              />
            </div>
          </KsButton>
        </div>
      </template>
    </KsDialog>
  </Teleport>
</template>
